export default "__VITE_ASSET__797ae8c2__"